import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ApiOrg } from 'api/org/types/ApiOrg';
import { ApiUnpublishedOrg } from 'api/org/types/ApiUnpublishedOrg';

export type MainStoreOrgsState = {
  byId: Record<
    string,
    {
      org?: ApiOrg | ApiUnpublishedOrg;
      isFetching?: boolean;
      isUnpublished?: boolean;
    }
  >;
};

// Slice

const orgsSlice = createSlice({
  name: 'orgs',
  initialState: {
    byId: {} as MainStoreOrgsState['byId'],
  },
  reducers: {
    fetchOrgRequest: (state: MainStoreOrgsState, action) => {
      state.byId[action.payload] = { isFetching: true };
    },
    fetchOrgSuccess: (
      state: MainStoreOrgsState,
      action: PayloadAction<ApiOrg | ApiUnpublishedOrg>,
    ) => {
      const orgId = action.payload.id;
      state.byId[orgId].isFetching = false;
      state.byId[orgId].org = action.payload;
    },
    setOrgUnpublished: (state: MainStoreOrgsState, action) => {
      state.byId[action.payload].isFetching = false;
      state.byId[action.payload].isUnpublished = true;
    },
    updateOrg: (state, action) => {
      state.byId[action.payload.id].org = action.payload;
    },
    partialUpdateOrg: (state, action) => {
      state.byId[action.payload.id] ||= {};
      state.byId[action.payload.id].org = {
        ...state.byId[action.payload.id].org,
        ...action.payload,
      };
    },
  },
});

export const orgsReducer = orgsSlice.reducer;

const {
  actions: {
    setOrgUnpublished,
    partialUpdateOrg,
    fetchOrgRequest,
    fetchOrgSuccess,
  },
} = orgsSlice;

export {
  setOrgUnpublished,
  partialUpdateOrg,
  fetchOrgRequest,
  fetchOrgSuccess,
};
